// extracted by mini-css-extract-plugin
module.exports = {"isShared":"menu-model_isShared__2pJdO"};